<template>
  <div class="coache-container">
    <el-tabs v-model="activeName" type="card" >
      <el-tab-pane label="基本信息" name="first">
        <el-form v-if="coach" class="user-from" label-width="140px" >
          <el-form-item class="label-line-height" label="上传头像" >
            <el-upload
              :on-success="handleSuccess"
              :on-error="handleError"
              :before-upload="beforeAvatarUpload"
              :show-file-list="false"
              :data="dataObj"
              :action="qiniuUp"
              :accept="accept"
              class="upload-size"
              list-type="picture-card">
              <el-popover
                placement="top-start"
                trigger="hover">
                <div class="popover-content"><img :src="coach.profile | ImageFormats" alt="img"/></div>
                <img slot="reference" v-show="coach.profile" :src="coach.profile | ImageFormats" >
              </el-popover>
              <i v-show="!coach.profile" class="el-icon-plus avatar-uploader-icon"/>
              <div slot="tip" class="el-upload__tip">只能上传图片，建议不超过5Mb</div>
            </el-upload>
          </el-form-item>
          <el-form-item label="用户姓名">
            <el-input v-model="coach.trueName" />
          </el-form-item>
          <el-form-item label="性别" >
            <el-radio v-model="coach.gender" label="男">男</el-radio>
            <el-radio v-model="coach.gender" label="女">女</el-radio>
          </el-form-item>
          <el-form-item label="国籍">
            <el-select v-model="coach.nationality" filterable placeholder="请选择国籍">
              <el-option label="中国" value="中国"/>
              <el-option label="其他" value="其他"/>
            </el-select>
          </el-form-item>
          <el-form-item label="出生日期" >
            <el-date-picker
              v-model="coach.birthday"
              type="date"
              placeholder="选择日期时间"/>
          </el-form-item>
          <el-form-item label="证件类型">
            <el-select v-model="coach.certificateType" filterable placeholder="身份证" @change="confirmCertificateType">
              <el-option v-for="item in certificateType" :key="item.id" :label="item.name" :value="item.id"/>
            </el-select>
          </el-form-item>
          <el-form-item label="证件号码">
            <el-input v-model="coach.certificateNum" />
          </el-form-item>
          <el-form-item label="证件正面">
            <el-upload
              :show-file-list="false"
              :data="dataObj"
              :action="qiniuUp"
              :accept="accept"
              :on-success="handleCertificateFront"
              :on-error="handleError"
              :before-upload="beforeAvatarUpload"
              class="upload-demo">
              <el-popover
                placement="top-start"
                trigger="hover">
                <div class="popover-content"><img :src="coach.certificateFrontImg | ImageCertFormats" alt="img"/></div>
                <img slot="reference" v-show="coach.certificateFrontImg" :src="coach.certificateFrontImg | ImageFormats" class="certificate-upload-style" >
              </el-popover>
              <div v-show="!coach.certificateFrontImg" class="certificate-upload-style" >
                选择上传文件
              </div>
              <div slot="tip" class="el-upload__tip">注：请上传运动员身份证正反面照片，并底衬A4纸附监护人/本人（16岁以上）签名</div>
            </el-upload>
          </el-form-item>
          <el-form-item label="证件反面">
            <el-upload
              :show-file-list="false"
              :data="dataObj"
              :action="qiniuUp"
              :accept="accept"
              :on-success="handleCertificateBack"
              :on-error="handleError"
              :before-upload="beforeAvatarUpload"
              class="upload-demo">
              <el-popover
                placement="top-start"
                trigger="hover">
                <div class="popover-content"><img :src="coach.certificateBackImg | ImageCertFormats" alt="img"/></div>
                <img slot="reference" v-show="coach.certificateBackImg" :src="coach.certificateBackImg | ImageFormats" class="certificate-upload-style" >
              </el-popover>
              <div v-show="!coach.certificateBackImg" class="certificate-upload-style" >
                选择上传文件
              </div>
              <div slot="tip" class="el-upload__tip">注：请上传运动员身份证正反面照片，并底衬A4纸附监护人/本人（16岁以上）签名</div>
            </el-upload>
          </el-form-item>
          <el-form-item label="身高(CM)">
            <el-input v-model="coach.high" />
          </el-form-item>
          <el-form-item label="体重(KG)">
            <el-input v-model="coach.weight" />
          </el-form-item>
          <el-form-item label="文化程度">
            <el-select v-model="coach.educationLevel" filterable placeholder="请选择">
              <el-option label="小学" value="小学"/>
              <el-option label="初中" value="初中"/>
              <el-option label="高中" value="高中"/>
              <el-option label="专科" value="专科"/>
              <el-option label="本科" value="本科"/>
              <el-option label="硕士" value="硕士"/>
              <el-option label="博士" value="博士"/>
            </el-select>
          </el-form-item>
          <el-form-item label="文化语种及程度">
            <el-select v-model="language.foreign" filterable placeholder="请选择语言">
              <el-option label="汉语" value="汉语"/>
              <el-option label="法语" value="法语"/>
              <el-option label="德语" value="德语"/>
              <el-option label="英语" value="英语"/>
              <el-option label="俄语" value="俄语"/>
              <el-option label="西班牙语" value="西班牙语"/>
              <el-option label="葡萄牙语" value="葡萄牙语"/>
              <el-option label="瑞典语" value="瑞典语"/>
            </el-select>
            <el-select v-model="language.level" filterable placeholder="请选择水平">
              <el-option label="一般" value="一般"/>
              <el-option label="良好" value="良好"/>
              <el-option label="熟练" value="熟练"/>
              <el-option label="精通" value="精通"/>
            </el-select>
          </el-form-item>
          <el-form-item label="再次注册年度" >
            <el-input v-model="coach.membershipYear" disabled />
            <el-dropdown trigger="click" placement="bottom">
              <span class="el-dropdown-link font-size-style">
                历史注册年度<i class="el-icon-arrow-down el-icon--right"></i>
              </span>
              <el-dropdown-menu slot="dropdown">
                <el-dropdown-item v-for="item in historyYears" :key="item.year">{{ item.year }}</el-dropdown-item>
              </el-dropdown-menu>
            </el-dropdown>
          </el-form-item>
          <el-form-item label="注册地">
            <el-select v-model="coach.area" filterable placeholder="请选择" style="width: 300px">
              <el-option v-for="(item, index) in areaList" :key="index" :label="item" :value="item" />
            </el-select>
          </el-form-item>
          <el-form-item label="请选择渠道">
            <el-select v-model="coach.source" filterable placeholder="请选择" style="width: 300px">
              <el-option v-for="(item, index) in sourceList" :key="index" :label="item" :value="item" />
            </el-select>
          </el-form-item>
          <el-form-item label="请填写其他渠道" v-if="coach.source==sourceList[3]">
            <el-input
              :rows="2"
              v-model="coach.otherSource"
              type="textarea"
              placeholder="请输入"/>
          </el-form-item>
          <el-form-item>
            <el-button v-permission="['user-coach-edit']" :loading="userLoding" type="primary" @click="setUserManage()" >保存</el-button>
            <!--<el-button type="info" plain>返回</el-button>-->
          </el-form-item>
        </el-form>

      </el-tab-pane>
      <el-tab-pane label="个人经历" name="second">
        <el-form v-if="coach" class="user-from" label-width="130px" >
          <el-form-item label="现所属会员单位/公司" >
            <el-select v-model="coach.organizationId" filterable placeholder="会员单位" style="width: 300px">
              <el-option v-for="item in organizationList" :key="item.id" :label="item.name" :value="item.id" />
            </el-select>
            <el-dropdown trigger="click" placement="bottom">
              <span class="el-dropdown-link font-size-style">
                历史会员单位<i class="el-icon-arrow-down el-icon--right"></i>
              </span>
              <el-dropdown-menu slot="dropdown">
                <el-dropdown-item v-for="item in historyOrgs" :key="item.id">{{ item.name }}</el-dropdown-item>
              </el-dropdown-menu>
            </el-dropdown>
          </el-form-item>
          <el-form-item label="现带领队伍名称">
            <el-input v-model="coach.coachingTeamName" placeholder="现带领队伍名称" />
          </el-form-item>
          <el-form-item label="场上位置" >
            <el-radio v-model="coach.position" label="前锋">前锋</el-radio>
            <el-radio v-model="coach.position" label="后卫">后卫</el-radio>
            <el-radio v-model="coach.position" label="手门员">守门员</el-radio>
          </el-form-item>
          <!--<el-form-item label="退役前供职球队名称" >-->
            <!--<el-input v-model="retireTeam" style="width: 160px;" width="160px" />-->
            <!--<el-date-picker-->
              <!--v-model="retireTime"-->
              <!--type="daterange"-->
              <!--range-separator="至"-->
              <!--start-placeholder="开始日期"-->
              <!--end-placeholder="结束日期"/>-->
            <!--<el-button type="info" @click="retireBeforeTeam()" >添加</el-button>-->
          <!--</el-form-item>-->
          <el-form-item label="退役前供职球队名称">
            <el-input
              v-model="coach.preRetirementTeamNames"
              placeholder="多个球队以', '分隔"/>
          </el-form-item>
          <el-form-item label="参赛成绩" >
            <el-input
              v-model="coach.competitionPerformance"
              :rows="3"
              type="textarea"
              placeholder="请输入内容"/>
          </el-form-item>
          <el-form-item>
            <el-button v-permission="['user-coach-edit']" :loading="userLoding" type="primary" @click="setUserManage()" >保存</el-button>
            <!--<el-button type="info" plain>返回</el-button>-->
          </el-form-item>
        </el-form>
      </el-tab-pane>
      <el-tab-pane label="执教经历" name="third">
        <el-form v-if="coach" class="user-from" label-width="130px" >
          <el-form-item class="retire" label="退役后供职公司名称/会员单位" >
            <el-input v-model="coach.exHirers" placeholder="多个会员单位以', '分隔" />
          </el-form-item>
          <el-form-item label="曾经带队名称" >
            <el-input v-model="coach.exCoachTeams" placeholder="多个球队以', '分隔" />
          </el-form-item>
          <el-form-item label="所持资格证证书" >
            <el-input v-model="coach.certificateLevel" placeholder="资格证证书" />
          </el-form-item>
          <!--<el-form-item label="现所持资格书等级" >-->
            <!--<el-select v-model="coach.certificateLevel" filterable placeholder="请选择等级">-->
              <!--<el-option label="高级" value="高级"/>-->
              <!--<el-option label="中级" value="中级"/>-->
              <!--<el-option label="普通" value="普通"/>-->
            <!--</el-select>-->
          <!--</el-form-item>-->
          <el-form-item label="发证单位" >
            <el-input
              v-model="coach.certificateIssuedBy"
              placeholder="单位名称"/>
          </el-form-item>
          <el-form-item label="取得成绩" >
            <el-input
              v-model="coach.coachingPerformance"
              type="textarea"
              rows="3"
              placeholder="请输入内容"/>
          </el-form-item>
          <el-form-item>
            <el-button v-permission="['user-coach-edit']" :loading="userLoding" type="primary" @click="setUserManage()" >保存</el-button>
            <!--<el-button type="info" plain>返回</el-button>-->
          </el-form-item>
        </el-form>
      </el-tab-pane>
      <el-tab-pane label="联系方式" name="four">
        <el-form v-if="coach" label-width="96px" class="lce-hockey-level" >
          <el-form-item label="固定电话" >
            <el-input
              v-model="coach.contactnumber"
              placeholder="请输入"/>
          </el-form-item>
          <el-form-item label="联系电话" >
            <el-input
              v-model="coach.mobile"
              placeholder="请输入"/>
          </el-form-item>
          <el-form-item label="邮箱" >
            <el-input
              v-model="coach.email"
              placeholder="请输入"/>
          </el-form-item>
          <el-form-item label="住址" >
            <el-input
              v-model="coach.address"
              placeholder="请输入"/>
          </el-form-item>
          <el-form-item>
            <el-button v-permission="['user-coach-edit']" :loading="userLoding" type="primary" @click="setUserManage()" >保存</el-button>
            <!--<el-button type="info" plain>返回</el-button>-->
          </el-form-item>
        </el-form>
      </el-tab-pane>
    </el-tabs>
  </div>
</template>

<script>
import moment from 'moment'
import permission from '@/directive/permission/index.js' // 权限判断指令
import { varConfig, showMessage, ImageFormat, ConstConfig, getDateObjectByString } from '@/utils'
import { getQiniuUploadToken, getSourceList } from '@/api/site'
import { getCoach, updateCoach } from '@/api/coach'
import { getOrganizationList, getHistoryMembershipYear, getHistoryOrganization } from '@/api/user'

const certificateType = ConstConfig.certificateType

export default {
  name: 'Details',
  directives: { permission },
  data() {
    return {
      activeName: 'first',
      coach: null,
      coachId: null,
      organizationId: null,
      userLoding: false,
      beforeTeam: null,
      retireTeam: null,
      retireTime: null,
      retireCompany: null,
      retireCompanyTime: null,
      dataObj: { token: '' },
      qiniuUp: varConfig.qiniuUp,
      accept: ConstConfig.accept,
      certificateType: certificateType,
      historyYears: [],
      historyOrgs: [],
      language: {},
      beforeTeamName: null,
      areaList: ['北京-长期', '非北京'],
      sourceList: []
    }
  },
  created() {
    this.coachId = this.$route.params.id
    // this.getCoachInfo()
    this.getOrganization()
    this.getQiniuToken()
    this.sourceList = getSourceList()
  },
  mounted() {},
  methods: {
    beforeAvatarUpload(file) {
      const isLt2M = file.size / 1024 / 1024 < 10
      if (!isLt2M) {
        showMessage('error', '上传头像图片大小不能超过 10MB!')
      }
      return isLt2M
    },
    handleSuccess(response) {
      this.$set(this.coach, 'profile', response.hash)
    },
    handleCertificateFront(response) {
      this.coach.certificateFrontImg = response.hash
    },
    handleCertificateBack(response) {
      this.coach.certificateBackImg = response.hash
    },
    getQiniuToken() {
      getQiniuUploadToken().then(response => {
        const data = response.data
        this.dataObj.token = data.token
      }).catch(err => {
        console.log(err, 'error', '七牛Token获取失败')
      })
    },
    handleError(file) {

    },
    confirmCertificateType(val) {
    },
    getCoachInfo() {
      const params = { id: this.coachId }
      getCoach(params).then((resolve) => {
        const coach = resolve.data
        if (coach.source) {
          if (!this.sourceList.includes(coach.source)) {
            coach.otherSource = coach.source
            coach.source = this.sourceList[3]
          }
        }
        this.coach = coach

        this.coach.birthday = getDateObjectByString(this.coach.birthday)
        if (this.coach.organizationId) {
          var self = this
          var organization = _.find(this.organizationList, function (item) {
            return item.id == self.coach.organizationId
          })
          this.coach.organizationId = organization ? organization.id : ''
        }
        if (this.coach.foreignLanguage && this.coach.foreignLanguage.indexOf('|')>-1) {
          const arr = this.coach.foreignLanguage.split('|')
          this.language = {
            foreign: arr[0],
            level: arr[1]
          }
        }
        this.getHistoryMembershipYear(this.coach.userId)
        this.getHistoryOrganization(this.coach.userId)
      }, (reject) => {})
    },
    getOrganization() {
      getOrganizationList().then((resolve) => {
        this.organizationList = resolve.data.list
        this.getCoachInfo()
      }, (reject) => {})
    },
    getHistoryMembershipYear(userId) {
      getHistoryMembershipYear(userId, 2).then(response => {
        const data = response.data
        this.historyYears = data.list
      }).catch(err => {
      })
    },
    getHistoryOrganization(userId) {
      getHistoryOrganization(userId, 2).then(response => {
        const data = response.data
        this.historyOrgs = data.list
      }).catch(err => {
      })
    },
    setUserManage() {
      ////
      let params = {
        id: this.coachId,
        profile: this.coach.profile,
        trueName: this.coach.trueName,
        gender: this.coach.gender,
        nationality: this.coach.nationality,
        birthday: this.coach.birthday ? moment(this.coach.birthday).format('YYYY-MM-DDTHH:mm:ss+0800'): '',
        certificateType: this.coach.certificateType,
        certificateNum: this.coach.certificateNum,
        certificateFrontImg: this.coach.certificateFrontImg,
        certificateBackImg: this.coach.certificateBackImg,
        organizationId: this.coach.organizationId,
        email: this.coach.email,
        area: this.coach.area,
        high: this.coach.high,
        weight: this.coach.weight,
        educationLevel: this.coach.educationLevel,
        foreignLanguage: this.coach.foreignLanguage,
        coachingTeamName: this.coach.coachingTeamName,
        position: this.coach.position,
        preRetirementTeamNames: this.coach.preRetirementTeamNames,
        competitionPerformance: this.coach.competitionPerformance,
        exHirers: this.coach.exHirers,
        exCoachTeams: this.coach.exCoachTeams,
        certificateLevel: this.coach.certificateLevel,
        certificateIssuedBy: this.coach.certificateIssuedBy,
        coachingPerformance: this.coach.coachingPerformance,
        contactnumber: this.coach.contactnumber,
        mobile: this.coach.mobile,
        address: this.coach.address
      }
      if(this.language.level) {
        params.foreignLanguage = this.language.foreign + '|' + this.language.level
      }
      if (this.coach.source === this.sourceList[3]) {
        params.source = this.coach.otherSource
      } else {
        params.source = this.coach.source
      }
      ////
      this.userLoding = true
      updateCoach(params).then((resolve) => {
        this.userLoding = false
        if (!resolve) {
          return
        }
        this.$message({
          message: '更新成功',
          type: 'success'
        })
      }, (reject) => {
        this.userLoding = false
        this.$message.error('数据保存失败')
      })
    },
    addRetireTeam(team, tiem, element) {
      if (!this[team] || !this[tiem] || !this.coach[element]) {
        return false
      }
      const stateTime = moment(this[tiem][0]).format('YYYY-MM')
      const overTime = moment(this[tiem][1]).format('YYYY-MM')
      this.coach[element] += '  ' + this[team] + stateTime + '~' + overTime + '、  '
    },
    retireBeforeTeam() {
      if (!this.retireTeam || !this.retireTime) {
        return
      }
      const stateTime = moment(this.retireTime[0]).format('YYYY-MM')
      const overTime = moment(this.retireTime[1]).format('YYYY-MM')
      this.coach.preRetirementTeamNames += this.retireTeam + stateTime + '~' + overTime
    },
    retireBeforeCompany() {
      if (!this.retireTeam || !this.retireTime) {
        return
      }
      const stateTime = moment(this.retireTime[0]).format('YYYY-MM')
      const overTime = moment(this.retireTime[1]).format('YYYY-MM')
      this.coach.preRetirementTeamNames += this.retireTeam + stateTime + '~' + overTime
    },
    addBeforeTeamName() {
      this.coach.exCoachTeams += '、' + this.beforeTeamName
    }
  },
  filters: {
    ImageFormats(img) {
      return ImageFormat.fileView(img)
    },
    ImageCertFormats(img) {
      return ImageFormat.imageView(img, 960, 594, 2)
    }
  }
}
</script>

<style rel="stylesheet/scss" lang="scss">
  .coache-container {
    margin: 30px 15px;
    .action-header {
      padding: 0 10px 10px 10px;
    }
    .el-table {
      th {
        div {
          line-height: 20px;
        }
        .el-select {
          padding-left: 0;
          padding-right: 0;
          .el-input {
            padding-left: 0;
            padding-right: 0;
          }
        }
      }
    }

    .table-footer {
      text-align: center;
      margin-top: 30px;
    }

    .upload-size .el-upload {
      width: 80px;
      height: 80px;
      border: 1px dashed #d9d9d9;
      border-radius: 6px;
      cursor: pointer;
      position: relative;
      overflow: hidden;
    }

    .avatar-uploader-icon {
      font-size: 28px;
      color: #8c939d;
      width: 78px;
      height: 78px;
      line-height: 78px !important;
      text-align: center;
      position: absolute;
      top: 0;
      left: 0;
    }

    .upload-size .el-upload:hover {
      border-color: #409EFF;
    }

    .upload-size .el-upload-list li {
      width: 80px;
      height: 80px;
    }

    .label-line-height .el-form-item__label {
      line-height: 80px;
      text-align: center;
    }

    .user-from .el-form-item__label {
      text-align: left;
      padding-left: 15px;
    }

    .certificate-upload-style {
      width: 120px;
      height: 32px;
      border: 1px solid #dcdfe6;
      border-radius: 4px;
      color: #999999;
      line-height: 32px;
    }

    .font-size-style {
      font-size: 14px;
      color: #169BD5;
      padding-left: 20px;
    }

    .team-info-width {
      width: auto;
      margin-right: 12px;
    }

    .el-upload img {
      width: 78px;
      height: 78px;
    }

    .el-date-editor .el-range-separator {
      width: auto;
    }

    .el-form .retire .el-form-item__content div {
      margin-bottom: 10px;
    }
    .el-input--small {
      max-width: 300px;
    }

    .el-dropdown {
      cursor: pointer;
    }
  }

  .el-popover .popover-content img {
    max-width: 360px;
  }
</style>
